export async function logoutUser() {
  window.location.href = encodeURI(window.location.origin + "/account/logout");
}
